import type { MeResponse } from "@/permissions/v2/types";

import type { APIInstance } from "./apiService";

export class MeService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getMe(): Promise<MeResponse> {
    const response = await this.api.get<MeResponse>("/me");
    return response.data;
  }
}
